<template>
  <el-dialog
    :close-on-click-modal="false"
    title="新增主卡"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="420px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  saveOrUpdateOilCard,
  servicerSelectList,
} from 'api/service';
import {
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        oilCardTypeOptions: [],
        userIdOptions: [], // 服务商
        form: [
          {
            label: '服务商',
            value: 'userId',
            type: 'select',
            placeholder: '请选择服务商名称',
          },
          {
            label: '主卡类型',
            value: 'oilCardType',
            type: 'select',
            placeholder: '请选择主卡类型',
            onChange: (oilCardType) => {
              if (this.$route.path.includes('gasCard')) {
                this.setFormAttrVal({
                  form: this.formData,
                  attr: 'hide',
                  value: oilCardType !== '6',
                  names: ['cardTypeRemark'],
                });
              }
            },
          },
          {
            label: '类型备注',
            value: 'cardTypeRemark',
            type: 'input',
            placeholder: '请输入类型备注',
            hide: true,
          },
          {
            label: '油卡卡号',
            value: 'oilCarNum',
            type: 'input',
            placeholder: '请输入油卡卡号',
          },
          {
            label: '当前余额',
            value: 'cardBalance',
            type: 'input',
            placeholder: '请输入当前余额',
            remark: '请填写当前余额，后续充值从平台发起！',
          },
        ],
        rules: {
          userId: [
            { required: true, message: '请选择服务商名称', trigger: 'blur' },
          ],
          oilCardType: [
            { required: true, message: '请选择主卡类型', trigger: 'blur' },
          ],
          oilCarNum: [
            { required: true, message: '请输入油卡卡号', trigger: 'blur' },
          ],
          cardBalance: [
            { required: true, message: '请输入当前余额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
      this.getFormSelectList();
      if (this.$route.path.includes('gasCard')) {
        this.$nextTick(() => {
          this.setFormAttrVal({
            form: this.formData,
            attr: 'hide',
            value: this.$refs.customForm.getVal('oilCardType') !== '6',
            names: ['cardTypeRemark'],
          });
          this.formData.form.forEach((item) => {
            if (item.label.includes('油卡')) {
              item.label = item.label.replace(/油卡/g, '气卡');
            }
            if (item.placeholder && item.placeholder.includes('油卡')) {
              item.placeholder = item.placeholder.replace(/油卡/g, '气卡');
            }
          });
          Object.keys(this.formData.rules).forEach((item) => {
            if (this.formData.rules[item][0].message.includes('油卡')) {
              this.formData.rules[item][0].message = this.formData.rules[item][0].message.replace(/油卡/g, '气卡');
            }
          });
        });
      }

    },

    async getFormSelectList () {
      const enumList = await getEnumList({
        codeType: 'SERV_OIL_CARD_TYPE,SERV_GAS_CARD_TYPE',
      });
      if (enumList && enumList.length) {
        this.formData.oilCardTypeOptions = this.$route.path.includes('gasCard') ? enumList[1] : enumList[0] ;
        this.$refs.customForm.setVal('oilCardType', this.formData.oilCardTypeOptions[0].value);
      }
      this.formData.userIdOptions = await servicerSelectList({
        serviceType: this.$route.path.includes('gasCard') ? 101 : 100,
      });
      if (this.formData.userIdOptions.length) {
        this.$refs.customForm.setVal('userId', this.formData.userIdOptions[0].value);
      }
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 对于主卡来说，油卡状态为 1，来源类型为 2
      // 油卡状态
      form.oilCardStatus = 1;
      // 来源类型
      form.cardType = 2;
      // 是否主卡
      form.isParent = 1;
      form.cardCategory = this.$route.path.includes('gasCard') ? 2 : 1;
      this.subLoading = true;
      const res = await saveOrUpdateOilCard(form);
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
